import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import './TopHeader.css';

const TopHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="top-header">
      <div className="container top-header-content">
        <div className="location-pill">
          <MapPin size={16} />
          <span>{t('top_header_address')}</span>
        </div>
        <div className="social-links">
          <span>{t('top_header_follow_us')}</span>
          <a href="https://www.facebook.com/atmasakshifoundation"><Facebook size={12} /></a>
          <a href="https://twitter.com/atmasakshifoundation"><Twitter size={12} /></a>
          <a href="https://www.instagram.com/atmasakshifoundation/"><Instagram size={12} /></a>
          <a href="https://www.youtube.com/@atmasakshifoundation"><Youtube size={12} /></a>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
